import React from "react";
import FileSaver, * as FileSave from "file-saver";
import XLSX from "sheetjs-style";
import { Tooltip } from "@mui/material";
import { ConvertDate } from "../../Function/ConvertDate";
import { DayGridView } from "@fullcalendar/daygrid";
import { isFriday } from "date-fns";

const ExcelExport = ({ excelData, fileName, reportType }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".csv";

  const exportToExcel = async (dataForExport) => {
    const ws = XLSX.utils.json_to_sheet(dataForExport);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const exelBuffer = XLSX.write(wb, { bookType: "csv", type: "array" });
    const data = new Blob([exelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const ConvertToFormatExcel = async (arr, exitData) => {
    if (arr && arr?.some((a) => a?.hasOwnProperty("user_id"))) {
      let csvArr = [];
      let cutDepartment = arr?.filter((item) =>
        item?.hasOwnProperty("user_id")
      );
      cutDepartment &&
        cutDepartment?.map((item,index) => {
          const matchDate = exitData?.filter((a) => {
            if (
              a?.date?.split("T")[0] === item?.date?.split("T")[0] &&
              a?.user_id === item?.user_id
            )
              return a?.date?.split("T")[0];
          });
          const workHours = parseInt(item?.user_start_work_name?.split(".")[0]);
          const workMinutes = parseInt(
            item?.user_start_work_name?.split(".")[1]
          );
          let workDecimal = 0;
          let dayWorkHours = 0;
          let dayWorkMinutes = 0;
          if (matchDate?.length !== 0) {
            const timeEntry = new Date(
              new Date(item?.scan_date).setHours(workHours, workMinutes, 0, 0)
            );
            const match = matchDate[0]?.scan_date;
            const matchDay = parseInt(match?.split("T")[0]?.split("-")[2]);
            const matchMonth = parseInt(match?.split("T")[0]?.split("-")[1]);
            const matchYear = parseInt(match?.split("T")[0]?.split("-")[0]);
            const matchHours = parseInt(
              match?.split("T")[1]?.split(".")[0].split(":")[0]
            );
            const matchMinutes = parseInt(
              match?.split("T")[1]?.split(".")[0].split(":")[1]
            );
            const matchSeconds = parseInt(
              match?.split("T")[1]?.split(".")[0].split(":")[2]
            );
            const matchMilliSec = parseInt(match?.split("T")[1]?.split("Z")[0]);
            const timeExit = new Date(
              matchYear,
              matchMonth - 1,
              matchDay,
              matchHours,
              matchMinutes,
              matchSeconds,
              matchMilliSec
            );
            
            const timeDifference = Math.abs(
              timeExit.getTime() - timeEntry.getTime()
            );
            const hours = Math.floor(timeDifference / (1000 * 60 * 60));
            const minutes = Math.floor(
              (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
            );
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            const workHoursDecimal =
              (hours || 0) + minutes / 60 + seconds / 3600;
            workDecimal = workHoursDecimal.toFixed(2);

            dayWorkHours = parseInt(matchDate[0]?.working_hours?.split(":")[0]);
            dayWorkMinutes = parseInt(matchDate[0]?.working_hours?.split(":")[1]);
          }
          let lateHours = item?.late_hours?.split(":")[0];
          let lateMinutes = item?.late_hours?.split(":")[1];

          let OTHours;
          let OTMinutes;
          let OTMoneys;
          
          if (matchDate && matchDate?.length !== 0) {
            if (
              parseInt(
                matchDate?.working_hours?.split(
                  ":"
                )[0]
              ) > 8
            ) {
              OTHours =
                parseInt(
                  matchDate?.working_hours?.split(
                    ":"
                  )[0]
                ) - 8;
              OTMinutes = parseInt(
                matchDate?.working_hours?.split(
                  ":"
                )[1]
              );
              OTMoneys =
                (parseInt(
                  matchDate?.working_hours?.split(
                    ":"
                  )[0]
                ) -
                  8) *
                50;
            }
          }

          let csvEntryExit = {
            "วันที่": ConvertDate(item?.date).toThaiDateDMY(),
            "รอบเวลา": item?.user_start_work_name,
            "ชื่อ-นามสกุล": `${item?.user_title_name}${item?.user_name}`,
            "เวลาเข้างาน": item?.entry_exit_status === 3 || item?.entry_exit_status === 4 || item?.entry_exit_status === 5 ? null 
                          : `${item?.scan_date?.split("T")[1]?.split(".")[0]}`,
            "สถานะการเข้างาน": item?.entry_exit_status === 0 ? item?.late === 1 ? "สาย" : "ปกติ" : null,
            "เวลาออก": matchDate?.length !== 0 ? `${matchDate[0]?.scan_date?.split("T")[1]?.split(".")[0]}` : "",
            "สถานะการออกงาน": matchDate?.length !== 0 && workDecimal > 8 ? "ล่วงเวลา" : null,
            "ชั่วโมงการทำงาน": item?.entry_exit_status === 3 || item?.entry_exit_status === 4 || item?.entry_exit_status === 5 ? null : matchDate?.length !== 0 ?
               `${dayWorkHours ? dayWorkHours : 0} ชั่วโมง ${dayWorkMinutes ? dayWorkMinutes : 0} นาที` : null,
            "เวลาการทำงาน": item?.entry_exit_status === 3 || item?.entry_exit_status === 4 ? item?.entry_exit_status_name : item?.entry_exit_status === 5 || (item?.entry_exit_status === 0 && matchDate?.length === 0)
                        ? item?.note : workDecimal > 8
                        ? "เต็มเวลา" : "ไม่เต็มเวลา",
          };

          let csvLate = {
            "วันที่": ConvertDate(item?.date).toThaiDateDMY(),
            "รอบเวลา": item?.user_start_work_name,
            "ชื่อ-นามสกุล": `${item?.user_title_name}${item?.user_name}`,
            "เวลาเข้างาน": item?.entry_exit_status === 3 || item?.entry_exit_status === 4 || item?.entry_exit_status === 5 ? null 
                          : `${item?.scan_date?.split("T")[1]?.split(".")[0]}`,
            "เวลาออก": matchDate?.length !== 0 ? `${matchDate[0]?.scan_date?.split("T")[1]?.split(".")[0]}` : "",
            "สถานะการออกงาน": matchDate?.length !== 0 && workDecimal > 8 ? "ล่วงเวลา" : null,
            "จำนวนชั่วโมงเข้าสาย": item?.late ? `${lateHours ? lateHours : 0} ชั่วโมง ${lateMinutes? lateMinutes: 0} นาที` : `0 ชั่วโมง 0 นาที`,
            "ชั่วโมงการทำงาน": item?.entry_exit_status === 3 || item?.entry_exit_status === 4 || item?.entry_exit_status === 5 ? null : matchDate?.length !== 0 ?
               `${dayWorkHours ? dayWorkHours : 0} ชั่วโมง ${dayWorkMinutes ? dayWorkMinutes : 0} นาที` : null,
            "เวลาการทำงาน": item?.entry_exit_status === 3 || item?.entry_exit_status === 4 ? item?.entry_exit_status_name : item?.entry_exit_status === 5 || (item?.entry_exit_status === 0 && matchDate?.length === 0)
                        ? item?.note : workDecimal > 8
                        ? "เต็มเวลา" : "ไม่เต็มเวลา",
          };

          let csvOT = {
            "วันที่": ConvertDate(item?.date).toThaiDateDMY(),
            "รอบเวลา": item?.user_start_work_name,
            "ชื่อ-นามสกุล": `${item?.user_title_name}${item?.user_name}`,
            "เวลาเข้างาน": item?.entry_exit_status === 3 || item?.entry_exit_status === 4 || item?.entry_exit_status === 5 ? null 
                          : `${item?.scan_date?.split("T")[1]?.split(".")[0]}`,
            "สถานะการเข้างาน": item?.entry_exit_status === 0 ? item?.late === 1 ? "สาย" : "ปกติ" : null,
            "เวลาออก": matchDate?.length !== 0 ? `${matchDate[0]?.scan_date?.split("T")[1]?.split(".")[0]}` : "",
            "สถานะการออกงาน": matchDate?.length !== 0 && workDecimal > 8 ? "ล่วงเวลา" : null,
            "ชั่วโมงการทำงาน": item?.entry_exit_status === 3 || item?.entry_exit_status === 4 || item?.entry_exit_status === 5 ? null : matchDate?.length !== 0 ?
               `${dayWorkHours ? dayWorkHours : 0} ชั่วโมง ${dayWorkMinutes ? dayWorkMinutes : 0} นาที` : null,
            "จำนวนชั่วโมงล่วงเวลา" : matchDate && matchDate.length !== 0 ? `${OTHours ? OTHours : 0} ชั่วโมง ${OTMinutes ? OTMinutes : 0} นาที`
            : null,
            "ค่าล่วงเวลา" : OTMoneys ?? null,
          };

          let csvNotFullTime = {
            "วันที่": ConvertDate(item?.date).toThaiDateDMY(),
            "รอบเวลา": item?.user_start_work_name,
            "ชื่อ-นามสกุล": `${item?.user_title_name}${item?.user_name}`,
            "เวลาเข้างาน": item?.entry_exit_status === 3 || item?.entry_exit_status === 4 || item?.entry_exit_status === 5 ? null 
                          : `${item?.scan_date?.split("T")[1]?.split(".")[0]}`,
            "สถานะการเข้างาน": item?.entry_exit_status === 0 ? item?.late === 1 ? "สาย" : "ปกติ" : null,
            "เวลาออก": matchDate?.length !== 0 ? `${matchDate[0]?.scan_date?.split("T")[1]?.split(".")[0]}` : "",
            "สถานะการออกงาน": matchDate?.length !== 0 && workDecimal > 8 ? "ล่วงเวลา" : null,
            "ชั่วโมงการทำงาน": item?.entry_exit_status === 3 || item?.entry_exit_status === 4 || item?.entry_exit_status === 5 ? null : matchDate?.length !== 0 ?
               `${dayWorkHours ? dayWorkHours : 0} ชั่วโมง ${dayWorkMinutes ? dayWorkMinutes : 0} นาที` : null,
            "เวลาการทำงาน": item?.entry_exit_status === 3 || item?.entry_exit_status === 4 ? item?.entry_exit_status_name : item?.entry_exit_status === 5 || (item?.entry_exit_status === 0 && matchDate?.length === 0)
                        ? item?.note : workDecimal > 8
                        ? "เต็มเวลา" : "ไม่เต็มเวลา",
          };

          
          // let csv = {
          //   summary_date: ConvertDate(item?.date).toThaiDateDMY(),
          //   user_start_work_name: item?.user_start_work_name,
          //   title_name: item?.user_title_name,
          //   user_name: item?.user_name,
          //   checkin_time: item?.entry_exit_status === 3 || item?.entry_exit_status === 4 || item?.entry_exit_status === 5 ? null 
          //                 : `${item?.scan_date?.split("T")[0]} ${item?.scan_date?.split("T")[1]?.split(".")[0]}`,
          //   checkin_status: null,
          //   checkin_type: item?.entry_exit_status === 0 ? matchDate?.length !== 0 ? 1 : 0 : null,
          //   checkout_time: matchDate?.length !== 0 ? `${matchDate[0]?.scan_date?.split("T")[0]} ${matchDate[0]?.scan_date?.split("T")[1]?.split(".")[0]}` : "",
          //   checkout_status: matchDate?.length !== 0 && workDecimal > 8 ? "ล่วงเวลา" : null,
          //   checkout_type: item?.entry_exit_status === 0 ? matchDate?.length !== 0 ? 1 : 0 : null,
          //   hours: item?.entry_exit_status === 3 || item?.entry_exit_status === 4 || item?.entry_exit_status === 5 ? null : matchDate?.length !== 0 ? workDecimal : null,
          //   day_status: item?.entry_exit_status === 3 || item?.entry_exit_status === 4 ? item?.entry_exit_status_name : item?.entry_exit_status === 5 || (item?.entry_exit_status === 0 && matchDate?.length === 0)
          //               ? item?.note : workDecimal > 8
          //               ? "เต็มเวลา" : "ไม่เต็มเวลา",
          // };
          csvArr.push(reportType === "1" ? csvEntryExit 
            : reportType === "2" ? csvLate 
              : reportType === "4" ? csvOT  
                : reportType === "5" ? csvNotFullTime
                  : null);
        });

      return csvArr;
    } 
  };

  const convertReportType6 = () => {
    let csvArr = [];
    excelData?.map((item) => {
      let csvLeaveEarly = {
        "วันที่": ConvertDate(item?.date).toThaiDateDMY(),
        "ชื่อ-นามสกุล": `${item?.user_title_name}${item?.created_user}`,
        "วันที่ขออนุญาตกลับก่อน": ConvertDate(item?.leave_from_date).toThaiDateDMY(),
        "การอนุมัติขั้นต้น": item?.leave_status === "0" || item?.leave_status === "5" || item?.leave_status === "3" ? "อนุมัติ" : null,
        "การอนุมัติ": item?.leave_status === "0" || item?.leave_status === "5" ? "อนุมัติ" : null,
        "เหตุผล": item?.leave_reason ?? null
      };
      csvArr.push(csvLeaveEarly)
    });
    return csvArr;
  }

  return (
    <React.Fragment>
      <Tooltip title="ดาวน์โหลด CSV">
        <button
          onClick={async (e) => {
            if (reportType !== "6") {
              await exportToExcel(
                await ConvertToFormatExcel(excelData[0], excelData[1])
              );
            } else {
              await exportToExcel(convertReportType6());
            }
          }}
          className="btn btn-success"
        >
          ดาวน์โหลด CSV
        </button>
      </Tooltip>
    </React.Fragment>
  );
};

export default ExcelExport;
